var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContactLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 55,
    height: 55.059,
    viewBox: "0 0 55 55.059",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "contact_linkedin",
    d: "M29.075,23.546c-.281-.253-.193-.544-.2-.8-.012-1.094-.035-2.19,0-3.283.026-.719-.255-.953-.962-.946q-4.253.043-8.506,0c-.7-.007-.961.212-.96.938q.025,17.311.013,34.623c0,.917.06.978.977.98q4.477.008,8.954,0c1.025,0,1.092-.068,1.092-1.112q0-8.059.007-16.118c0-.994.037-1.989.106-2.98a7.625,7.625,0,0,1,6.913-7.308,6.074,6.074,0,0,1,6.359,3.342,10.644,10.644,0,0,1,1.086,4.981c.013,6.044,0,12.088.007,18.132,0,1.007.055,1.062,1.056,1.063q4.365.006,8.731,0c1.237,0,1.241,0,1.242-1.253q0-10.223,0-20.446a23.28,23.28,0,0,0-.172-3.126,14.172,14.172,0,0,0-4.256-8.9c-3.475-3.208-7.633-4.1-12.2-3.32a14.714,14.714,0,0,0-7.957,3.968c-.488.474-.889,1.036-1.339,1.567M.975,36.793q0,8.621,0,17.242c0,.95.072,1.02,1.023,1.022q4.478.007,8.957,0c.975,0,1.046-.067,1.046-1q0-17.279,0-34.558c0-.913-.063-.971-.985-.972q-4.441-.006-8.882,0c-1.15,0-1.16.009-1.16,1.174q0,8.546,0,17.092M6.548,12.946a6.352,6.352,0,0,0,6.445-6.353,6.5,6.5,0,1,0-6.445,6.353",
    transform: "translate(0)",
    fill: "#5637fa"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactLinkedin);
export default __webpack_public_path__ + "static/media/contact_linkedin.f449634c84a4184dfce33f6ae5a95d40.svg";
export { ForwardRef as ReactComponent };